


























































import Vue from "vue";
import Ellipsis from "@/components/Ellipsis.vue";
import { safeJsonParse } from "@/utils/safe-json-parse";
import { convert_instanceid_to_uuid } from "@/utils/convert-instanceid-to-uuid";
import { convert_uuid_byte } from "@/utils/convert-uuid-to-byteid";
import { DesignFileView } from "@/api/custom-simulation";
import {
FileExtension,
    SimulationType,
    SimulationTypeEnglishText,
    SimulationTypeText
} from "@/constants/custom-simulation";
import { isEmpty } from "lodash-es";
import { getComponentInformation } from "@/api/model-view";
import { Message } from "element-ui";
import { recombinateComponentDetail } from "@/utils/recombinate-component-detail";
import { filePreview } from "@/utils/filepreview";
import SimulationPreviewModal from "../simulation-preview-modal/index.vue";

export default Vue.extend({
    components: { Ellipsis, SimulationPreviewModal },
    data() {
        return {
            selectedItem: null as DesignFileView | null,
            previewModalVisible: false,
            previewItem: {},
            judgeList: {} as Record<string, boolean>
        };
    },
    computed: {
        bindedList(): DesignFileView[] {
            const list: DesignFileView[] = this.$store.getters["customSimulationModule/bindedList"] || [];
            if (this.isTwoThreeDimension) {
                return list.sort(
                    (a, b) =>
                        safeJsonParse(a.viewSettings).index - safeJsonParse(b.viewSettings).index
                );
            }
            return list;
        },
        currentSimulationType(): SimulationType {
            return this.$store.state.customSimulationModule.currentSimulationResource.designFile?.classType || SimulationType.exercises;
        },
        title(): string {
            return SimulationTypeText[this.currentSimulationType];
        },
        englishTitle(): string {
            return SimulationTypeEnglishText[this.currentSimulationType];
        },
        modelId(): string {
            return this.$store.state.customSimulationModule.currentSimulationResource?.uploadFile
                ?.fileId;
        },
        isTwoThreeDimension(): boolean {
            return (
                this.currentSimulationType ===
                SimulationType.twoDimensionalAndThreeDimensionalComparison
            );
        },
        isFold(): boolean {
            return this.$store.state.customSimulationModule.isFold;
        }
    },
    methods: {
        getJudgeColor(item: DesignFileView) {
            const { index } = safeJsonParse(item.viewSettings);
            const result = this.judgeList[`${index}`];
            if (result === undefined) {
                return "";
            }
            return result ? "#7dfb5a" : "brown";
        },
        getIndex(item: DesignFileView) {
            return safeJsonParse(item.viewSettings).index;
        },
        checkLink(item: DesignFileView) {
            const { selectedInstanceId } = this.$store.state.customSimulationModule;
            const { componentIds, index } = safeJsonParse(item.viewSettings);
            if (!selectedInstanceId) {
                Message.warning("请先在模型中选择构件！");
                return;
            }
            if (componentIds.includes(selectedInstanceId)) {
                Message.success("恭喜你，构件关联判断正确。");
                this.$set(this.judgeList, index, true);
            } else {
                Message.error("很遗憾，构件关联判断错误。");
                this.$set(this.judgeList, index, false);
            }
        },
        async selectItem(item: DesignFileView) {
            this.selectedItem = item;
            const compoentIds = safeJsonParse(item.viewSettings).componentIds.map(v =>
                convert_uuid_byte(convert_instanceid_to_uuid(v, 1))
            );
            const api3d = this.$store.getters["modelViewModule/api3d"];
            const twoDapi3d = this.$store.getters['modelViewModule/twoDapi3d'];
            const { style } = safeJsonParse(item.viewSettings);
            const { perspective } = safeJsonParse(item.viewSettings);
            const { twoDPerspective } = safeJsonParse(item.viewSettings);
            const { markerInfo = {} } = safeJsonParse(item.viewSettings);
            const { deviceId = "" } = markerInfo;
            const { componentId = "" } = markerInfo;
            const info: any = {
                state: 0,
                deviceId,
                isFlicker: true,
                subLineRadian: Math.PI / 4,
                subLineLength: 200,
                customColor: "#DDDDDDDD"
            };
            const content = this.$refs[item.id!]![0] as HTMLElement;
            const res = await getComponentInformation({
                modelId: this.modelId,
                instanceId: safeJsonParse(item.viewSettings).componentIds[0]
            });
            if (res.status.error !== 0) {
                this.$message.error(res.status.errorDesc);
                return;
            }
            const componentDetails = recombinateComponentDetail(res.instanceProperty.propertySets);
            this.$store.commit("simulationRightMenuModule/setComponentInformations", {
                name: res.instanceProperty.name,
                details: componentDetails
            });
            // this.$store.commit("simulationRightMenuModule/setActiveName", "attribute");
            switch (this.currentSimulationType) {
                case SimulationType.modelBrowsing:
                    if (style === "highlight") {
                        api3d.showAll();
                        api3d.restoreHighLightRenderElement();
                        compoentIds.forEach(v => {
                            api3d.highLightRenderElement(v);
                        });
                    }
                    if (style === "quarantine") {
                        api3d.isolationRenderElement(compoentIds, 0.2);
                        api3d.update();
                    }
                    return;
                case SimulationType.componentIntroduction:
                    if (isEmpty(markerInfo)) {
                        return;
                    }
                    api3d && api3d.removeAllMarkerDeviceInfo();
                    api3d.markerDeviceInfoByComponentId(
                        convert_uuid_byte(convert_instanceid_to_uuid(componentId, 1)),
                        info
                    );
                    info.div.appendChild(content);
                    content.style.height = "unset";
                    content.style.padding = "24px";
                    content.style.overflow = "visible";
                    api3d.showAll();
                    api3d.update();
                    api3d.restoreHighLightRenderElement();
                    api3d.restoreCameraView({
                     isAnimation: true,
                    });
                    setTimeout(() => {
                        perspective && api3d.setCurrentLook(perspective, true);
                    }, 700);
                    compoentIds.forEach(v => {
                        api3d.highLightRenderElement(v);
                    });
                    return;
                case SimulationType.auxiliaryPositioning:
                    api3d.showAll();
                    api3d.update();
                    api3d.restoreHighLightRenderElement();
                    compoentIds.forEach(v => {
                        api3d.highLightRenderElement(v);
                    });
                    api3d.restoreCameraView({
                     isAnimation: true,
                    });
                    setTimeout(() => {
                        perspective && api3d.setCurrentLook(perspective, true);
                    }, 700);
                    break;
                case SimulationType.twoDimensionalAndThreeDimensionalComparison:
                    // api3d.showAll();
                    // api3d.update();
                    // api3d.restoreHighLightRenderElement();
                    // compoentIds.forEach(v => {
                    //     api3d.highLightRenderElement(v);
                    // });
                    twoDapi3d.restoreCameraView({
                     isAnimation: false,
                    });
                    twoDapi3d.setCurrentLook(twoDPerspective, true);

                    break;
                default:
                    break;
            }
        },
        isSelected(item: DesignFileView) {
            return this.selectedItem?.id === item.id;
        },
        getFileList(data) {
            return safeJsonParse(data)?.uploadFiles || [];
        },
        getIntro(data) {
        return safeJsonParse(data)?.intro || '';
        },
        preview(fileItem: { path?: any; name?: any }) {
      const index = fileItem.path.lastIndexOf('%2E') + 3;
      const fileExtention = fileItem.path.slice(index);
      if (FileExtension.includes(fileExtention.toUpperCase())) {
        filePreview({
          fileUrl: fileItem.path,
          fileName: fileItem.name,
          fileExtention: fileItem.path.slice(index),
        });
      } else {
        this.previewModalVisible = true;
        this.previewItem = fileItem;
      }
    },
    }
});
